import dayjs from "dayjs";

export function isSameData(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}

export function buildQuery(params) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      searchParams.append(key, value);
    }
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export function formatTimestamp(value) {
  return value ? dayjs(value).format("YYYY-MM-DD HH:mm:ss") : "-";
}

export function getDefaultAuditFilters() {
  return {
    email: "",
    studentId: "",
    studentLabel: "",
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  };
}
// The backend's error body carries a human sentence in `message` ("You cannot
// remove your own ADMIN access…", "Unknown grant…"); prefer it to the
// HttpError's "PUT … failed (403) {…}" wrapper.
export function errorText(error, fallback) {
  const fromBody = error?.body && typeof error.body === "object" ? error.body.message : null;
  return fromBody || error?.message || fallback;
}
